var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrowth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m392 418h-272.021c-66.156 0-119.979-53.822-119.979-119.979v-164.021c0-66.168 53.832-120 120-120h198c11.046 0 20 8.954 20 20s-8.954 20-20 20h-198c-44.112 0-80 35.888-80 80v164.021c0 44.1 35.879 79.979 79.979 79.979h272.021c44.112 0 80-35.888 80-80v-90c0-11.046 8.954-20 20-20s20 8.954 20 20v90c0 66.168-53.832 120-120 120zm-20 60c0-11.046-8.954-20-20-20h-192c-11.046 0-20 8.954-20 20s8.954 20 20 20h192c11.046 0 20-8.954 20-20zm140-350v-52.823c0-33.734-27.443-61.177-61.176-61.177h-52.824c-11.046 0-20 8.954-20 20s8.954 20 20 20h52.824c11.676 0 21.176 9.5 21.176 21.177v52.823c0 11.046 8.954 20 20 20s20-8.954 20-20zm-69.545-12.197c7.628-7.988 7.336-20.648-.652-28.276s-20.648-7.337-28.277.651c-48.539 50.829-113.006 78.822-181.526 78.822h-11.821c-11.046 0-20 8.954-20 20s8.954 20 20 20h11.821c79.554 0 154.295-32.388 210.455-91.197z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowth);
export default __webpack_public_path__ + "static/media/growth.bc2937f7d470c107a9919aebc576d231.svg";
export { ForwardRef as ReactComponent };